import {useState} from 'react';
import {api} from "../services/Api/api";
import {useNavigate} from "react-router-dom";
import AppConfig from "../services/AppConfig";
import {usePrefix} from "../services/Prefix";

interface Props {
	menuItems: any[];
	handleOpenItemsModal: () => void;
	menus: any[];
	categories: any[];
}

export const useVoucherProducts = ({menuItems, handleOpenItemsModal, menus, categories}: Props) => {
	const navigate = useNavigate();
	const prefix = usePrefix();
	const [promotionItems, setPromotionItems] = useState<any[]>([]);

	const fetchPromotion = (promotionId?: string) => {
		if (!promotionId) return;

		try {
			return api.getPromotion(promotionId);
		}
		catch (error) {}
	}

	const findMenuForPromotionItem = (promotionItem: any) => {
		const itemCategory = categories.find(category => category.entities.map((entity: any) => entity.entity_id).includes(promotionItem.id));

		return menus.find(menu => {
			const category = menu.categories.find((menuCategory: any) => menuCategory.category_id === itemCategory.id);

			if(category) return menu.id;

			return undefined;
		})?.id;
	}

	const findPromotionItemsInMenu = (promotionItems: any[]) => {
		const promotionItemsIds = promotionItems.map(item => item.entity_id);

		return menuItems.filter(menuItem => {
			return promotionItemsIds.includes(menuItem.id);
		})
	}
	const handlePromotionChange = async (promotionId?: string) => {
		const promotion = await fetchPromotion(promotionId);

		if(!promotion) return;

		const promotionItems = findPromotionItemsInMenu(promotion.entities.filter((entity: any) => entity.type === "ITEM"));
		setPromotionItems(promotionItems)

		if(promotionItems.length === 1) {
			const menuId = findMenuForPromotionItem(promotionItems[0]);

			if(menuId) {
				navigate(AppConfig.getLinkWithPrefix(`/menu/${menuId}/add/${promotionItems[0].id}`, prefix), {state: {back: true}});
			}

		}
		else if(promotionItems.length > 1) {
			handleOpenItemsModal();
		}
	}

	return {
		handlePromotionChange,
		findMenuForPromotionItem,
		promotionItems
	};
}